module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-es-ES.0be070bd.jpg";